import { RSAA, RSAAAction } from 'redux-api-middleware'
import { Env, getEnv } from '@cinch/oxd-utils/env/src'
import { Action, ActionCreator } from 'redux'
import { enrichOrderDetailsResponse } from '@cinch/oxd-pages/order-confirmation/src/types'

import {
  ORDER_CREATE_COMPLETE,
  ORDER_CREATE_ERROR,
  ORDER_CREATE_REQUEST,
  ORDER_DETAILS_COMPLETE,
  ORDER_DETAILS_ERROR,
  ORDER_DETAILS_REQUEST,
  ORDER_DETAILS_UPDATED,
  VEHICLE_DETAILS_COMPLETE,
  VEHICLE_DETAILS_ERROR,
  VEHICLE_DETAILS_REQUEST,
} from '../types'

const ORDER_SERVICE_URL = getEnv(Env.OrderServiceUrl)
const INVENTORY_SERVICE_URL = getEnv(Env.InventoryServiceUrl)

export interface CreateOrderActionPayload {
  vehicleId: string
  firstName: string
  lastName: string
  email: string
}

export const createOrder = (payload: CreateOrderActionPayload): RSAAAction => {
  return {
    [RSAA]: {
      endpoint: `${ORDER_SERVICE_URL}/order/create`,
      method: 'POST',
      body: JSON.stringify(payload),
      types: [ORDER_CREATE_REQUEST, ORDER_CREATE_COMPLETE, ORDER_CREATE_ERROR],
    },
  }
}

export const getVehicleDetails = (vehicleId: string): RSAAAction => {
  return {
    [RSAA]: {
      endpoint: `${INVENTORY_SERVICE_URL}/vehicle/${vehicleId}`,
      method: 'GET',
      types: [VEHICLE_DETAILS_REQUEST, VEHICLE_DETAILS_COMPLETE, VEHICLE_DETAILS_ERROR],
    },
  }
}

export const getOrderDetails = (orderId: string): RSAAAction => {
  return {
    [RSAA]: {
      endpoint: `${ORDER_SERVICE_URL}/order/${orderId}`,
      method: 'GET',
      types: [ORDER_DETAILS_REQUEST, ORDER_DETAILS_COMPLETE, ORDER_DETAILS_ERROR],
    },
  }
}

export const newOrderDetailsReceived: ActionCreator<Action> = (response: Cinch.OrderDetailsResponse) => {
  return {
    type: ORDER_DETAILS_UPDATED,
    payload: enrichOrderDetailsResponse(response),
  }
}
